// CSV export helpers.
//
// The app had six hand-rolled blob/anchor exports, and three of them did not quote fields —
// so any value containing a comma (a location name, a component description) silently
// corrupted the file. Everything new should go through here.
//
// Excel is the destination for all of these, which drives two choices: CRLF line endings,
// and a UTF-8 BOM so accented characters and the en-dashes used throughout the UI survive.

export const csvQuote = (v) => '"' + String(v ?? "").replace(/"/g, '""') + '"';

// rows: array of arrays. The first row is normally the header.
export const toCsv = (rows) => (rows || []).map(r => (r || []).map(csvQuote).join(",")).join("\r\n");

export const csvFilename = (basename, now = new Date()) =>
  basename + "-" + now.toISOString().slice(0, 10) + ".csv";

// Triggers a download. Returns false when the browser blocked it, so callers can surface
// a message rather than failing silently.
export const downloadCsv = (rows, basename) => {
  try {
    // ﻿ = UTF-8 BOM. Without it Excel reads the file as the system codepage.
    const blob = new Blob(["﻿" + toCsv(rows)], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = csvFilename(basename);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    // Revoke on the next tick — revoking synchronously can cancel the download in Safari.
    setTimeout(() => URL.revokeObjectURL(url), 0);
    return true;
  } catch (err) {
    console.error("CSV export failed", err);
    return false;
  }
};
